import { update } from 'Emitter';
import { MEASUREMENT } from 'StateEvents';
import { report } from './Reporters';
import repeatableRequests from './RepeatableRequests';

export default class ReportingManager {
  constructor() {
    this.submittedRequests  = [];
    this.repeatableRequests = repeatableRequests;
  }

  onUpdate(nextState, prevState, changes) {
    if(nextState.measurement.request_queue.length) {
      const nextItems = nextState.measurement.request_queue.find(this.nextRequest.bind(this));
      
      if(nextItems) {
        this.submittedRequests.push(nextItems.name);
        this.flushQueue(nextItems);
      }
    }
  }

  flushQueue(nextItems) {
    update(MEASUREMENT.LOG_PROGRESS, 'flushQueue', nextItems);
    this.requestNext(nextItems).then(this.handleComplete.bind(this, nextItems));
  }

  requestNext(items) {
    return (
      Promise.all(
          items
            .events
            .map(event => report([event]).catch(console.error))
        )
    )
  }

  handleComplete(nextItems) {
    this.submittedRequests = this.submittedRequests.filter( request => this.repeatableRequests.indexOf(nextItems.name) > -1 && request === nextItems.name );
    update(MEASUREMENT.LOG_COMPLETE, 'flushQueue', nextItems);
    // Mark measurement event complete
    update(nextItems.name, 'flushQueue');
  }

  nextRequest(request) {
    return !request.inprogress && this.submittedRequests.indexOf(request.name) === -1;
  }
}


// WEBPACK FOOTER //
// ./src/Services/Reporting/ReportingManager.js